<template>
    <div class="myCodeBox">
        <div class="message">
<!--            <img src="../../assets/img/headPortrait.png" alt="">-->
            <el-image
                style="width: 100px; height: 100px"
                :src="base64Imagedata"
                :preview-src-list="srcList">
            </el-image>
            <h1>运营商推广码</h1>
        </div>
        <div class="representativeBox">
            <div class="representative">
                <img src="../../assets/img/link.png" alt="">
                <div class="certificate">
                    <p>pc端推广链接：{{promotionData.pc_link}}</p>
                </div>
            </div>
            <div class="administrator">
                <img src="../../assets/img/link.png" alt="">
                <div class="certificate">
                    <p>手机端推广链接：{{promotionData.wap_link}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getMySpreadCode } from '@/api/operator';

export default {
    name:'myCode',
    data(){
        return{
            srcList: [],
            promotionData:'',
            base64Imagedata:'',
        }
    },
    created(){
        getMySpreadCode().then(res=>{
            if (res.code == 200) {
                this.promotionData = res.data;
                this.srcList = [
                    'data:image/png;base64,' + res.data.base64Imagedata
                ]
               this.base64Imagedata = 'data:image/png;base64,' + res.data.base64Imagedata
            }else{
                this.$message.error(res.msg)
            }
        })
    }
}
</script>

<style scoped>
    .myCodeBox{
        margin: 10px;
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .message{
        padding: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .message>img{
        width: 100px;
        height: 100px;
    }
    .message>h1{
        margin: 20px 0px;
        color: #76787a;
    }
    .representativeBox{
        color: #5e5e60;
        display: flex;
        flex-direction: column;
        margin: 20px;
    }
    .representative,
    .administrator{
        margin: 0px 10px;
/*        display: flex;
        align-items: center;
        justify-content: space-between;*/
        border-radius: 10px;
        padding: 20px;
        border: 1px solid #c8c8ca;
    }
    .representative,
    .administrator{
        display: grid;
        grid-template-columns: 100px 3fr;
        align-items: center;
        grid-template-rows: auto;
        margin-bottom: 10px;
    }
    .certificate{
        width: 90%;
    }
    .certificate>P{
        margin-bottom: 5px;
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>